import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { IEvent } from 'src/app/shared/models/event';
import { WeekDay } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ModalDetailEventComponent } from '../modal-detail-event/modal-detail-event.component';
import { ModalCreateEventComponent } from '../modal-create-event/modal-create-event.component';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();
  calendarEvents: CalendarEvent[] = []; 
  loading = false;
  selectedEvent: IEvent | null = null; // To store the selected event details
  /**
   * @hidden
   */
   columnHeaders: WeekDay[];
   
  constructor(public dataService: DataService,
    public dialog: MatDialog, 
    public authService: AuthService) {
      this.dataService.$eventSaved.subscribe((res)=>{
        this.dialog.closeAll();
        this.setUp();
      })
  }

  async ngOnInit() {
   await this.setUp()
  }

  async setUp() {
    this.fetchEventsForCurrentMonth();
    const monthNotifications = await this.dataService.getNotificationsCountForCurrentMonth(this.authService.userData.brandId);
  
    this.loading = false;
    this.dataService.monthNotifications = Math.abs(monthNotifications - this.authService.userData.notificationsPerMonth);
 
  }

  transformToCalendarEvents(events: IEvent[]): CalendarEvent[] {
    return events.map(event => ({
      id: event.id,
      start: new Date(event.startDateOfEvent.seconds * 1000),
      end: new Date(event.dueDateOfEvent.seconds * 1000),
      title: event.fullName,
      color: this.getRandomVividColor(), // Adjust color as needed
      actions: [], // Add actions if needed
      allDay: false, // Set to true if the event spans the entire day
      meta: event // You can store the original event data here
    }));
  }

  getRandomVividColor(): { primary: string; secondary: string } {
    // Generate random values for RGB
    const randomColor = () => Math.floor(Math.random() * 256);
  
    // Generate a random vivid color
    const primaryColor = `rgb(${randomColor()}, ${randomColor()}, ${randomColor()})`;
    
    // You can adjust secondary color as needed
    const secondaryColor = '#D1E8FF';
  
    return { primary: primaryColor, secondary: secondaryColor };
  }

  onDayClick(date: Date): void {
    this.dialog.open(ModalCreateEventComponent, {
        height: '80vh', 
        width: '70vw',
        data: {
          day: date
        }
    });
  }

  onEventClick(selectedEvent: any): void {
    // Handle event click to show details
    this.selectedEvent = selectedEvent;
    const ref  = this.dialog.open(ModalDetailEventComponent, {
        data: {
          event: selectedEvent.meta
        },
        height: '80vh', 
        width: '70vw'
    });
    event.stopPropagation(); 
  }

  closeDetails(): void {
    // Close the details card
    this.selectedEvent = null;
  }

  nextMonth(): void {
    this.viewDate.setMonth(this.viewDate.getMonth() + 1);
    this.fetchEventsForCurrentMonth();

  }

  lastMonth(): void {
    this.viewDate.setMonth(this.viewDate.getMonth() - 1);
    this.fetchEventsForCurrentMonth();
  }

  private async fetchEventsForCurrentMonth() {
    this.loading = true;
    if (!this.authService.userData.brandId) {
      this.authService.signOut();
    } else {
      const events = await this.dataService.getEventsFromUser(this.authService.userData.brandId);
      this.calendarEvents = this.transformToCalendarEvents(events);
    }
    this.loading = false;
  }
  /* Function to get background color based on the first letter of the event */
  getLabelBackgroundColor(event: any): string {
    const firstLetter = event.title.charAt(0).toUpperCase();
    const colorMap: { [key: string]: string } = {
      A: '#FF5733', // Example color for letter 'A'
      B: '#3366FF', // Example color for letter 'B'
      C: '#FFCC00', // Example color for letter 'C'
      D: '#66FF33', // Example color for letter 'D'
      E: '#FF3366', // Example color for letter 'E'
      F: '#9966CC', // Example color for letter 'F'
      G: '#FF9900', // Example color for letter 'G'
      H: '#3399FF', // Example color for letter 'H'
      I: '#FF6666', // Example color for letter 'I'
      J: '#6699CC', // Example color for letter 'J'
      K: '#FFCC66', // Example color for letter 'K'
      L: '#33CC99', // Example color for letter 'L'
      M: '#FF3366', // Example color for letter 'M'
      N: '#66FF33', // Example color for letter 'N'
      O: '#FF9966', // Example color for letter 'O'
      P: '#3399FF', // Example color for letter 'P'
      Q: '#FF3333', // Example color for letter 'Q'
      R: '#9966CC', // Example color for letter 'R'
      S: '#FF9900', // Example color for letter 'S'
      T: '#3399FF', // Example color for letter 'T'
      U: '#FFCC00', // Example color for letter 'U'
      V: '#3366FF', // Example color for letter 'V'
      W: '#FF5733', // Example color for letter 'W'
      X: '#9966CC', // Example color for letter 'X'
      Y: '#33CC99', // Example color for letter 'Y'
      Z: '#FF6666', // Example color for letter 'Z'
      // Add more colors for other letters as needed
    };
    
    return colorMap[firstLetter] || '#808080'; // Default color if no match
  }

  isCurrentMonth(day: any): boolean {
    const currentMonth = this.viewDate.getMonth();
    const dayMonth = day.date.getMonth();
    return currentMonth === dayMonth;
  }

}
